const slimNavbar = () => {
  const subscriptionFlash = document.getElementById('subscription-flash');
  const navbar = document.querySelector('.navbar');
  const flashDisplayed = subscriptionFlash !== null;

  if (flashDisplayed) {
    navbar.classList.add('navbar--shrink');
  } else {
    navbar.classList.remove('navbar--shrink');
  }
};

const bindNavbar = () => {
  document.addEventListener('DOMContentLoaded', () => {
    slimNavbar();
  });
};

export default bindNavbar;
